import React, { useState } from 'react';
import ModalHeader from '../ModalHeader';

const DISCHARGE_STATUSES = [
	{ value: 'NORMAL', label: 'Normal Discharge', description: 'Patient discharged as planned' },
	{ value: 'DAMA', label: 'DAMA', description: 'Discharged Against Medical Advice' },
	{ value: 'LAMA', label: 'LAMA', description: 'Left Against Medical Advice' },
];

const ModalDischargeStatus = ({ closeModal, confirmDischarge }) => {
	const [status, setStatus] = useState('NORMAL');

	return (
		<div className="onboarding-modal modal fade animated show" role="dialog" style={{ display: 'block' }}>
			<div className="modal-dialog modal-centered" style={{ maxWidth: '480px' }}>
				<div className="modal-content text-center">
					<ModalHeader closeModal={closeModal} title="Discharge Status" />
					<div className="onboarding-content with-gradient">
						<div className="element-box p-2">
							<div className="row" style={{ textAlign: 'left' }}>
								<div className="col-sm-12">
									<div className="form-group">
										<label>Select the discharge status</label>
										{DISCHARGE_STATUSES.map(item => (
											<div
												key={item.value}
												className="form-check p-2 mb-2"
												style={{
													border: `1px solid ${status === item.value ? '#4F81E1' : '#e2e5ec'}`,
													borderRadius: '6px',
													cursor: 'pointer',
												}}
												onClick={() => setStatus(item.value)}
											>
												<input
													className="form-check-input"
													type="radio"
													name="discharge_type"
													id={`discharge-type-${item.value}`}
													checked={status === item.value}
													onChange={() => setStatus(item.value)}
												/>
												<label className="form-check-label w-100" htmlFor={`discharge-type-${item.value}`} style={{ cursor: 'pointer' }}>
													<strong>{item.label}</strong>
													<div className="small text-muted">{item.description}</div>
												</label>
											</div>
										))}
									</div>
								</div>
								<div className="col-sm-12 mt-2">
									<div className="form-inline" style={{ justifyContent: 'center' }}>
										<button onClick={() => confirmDischarge(status)} className="btn btn-primary">
											Discharge Patient
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModalDischargeStatus;
